import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import { CosmosPreset } from './app-preset';

export const LOCAL_STORAGE_THEME_KEY = 'ui.theme.presetKey';
export const LOCAL_STORAGE_NAME_KEY = 'ui.theme.customName';
/**
 * CEMEX Preset
 * Custom theme for CEMEX Digital Concrete
 */
const CemexPreset = definePreset(Aura, {
  semantic: {
    primary: Aura.primitive.blue,
    secondary: Aura.primitive.red,
    // {
    //     50: '#f2f2fb',
    //     100: '#c2c2ed',
    //     200: '#9191de',
    //     300: '#6161d0',
    //     400: '#3030c1',
    //     500: '#0000b3',
    //     600: '#000098',
    //     700: '#00007d',
    //     800: '#000062',
    //     900: '#000048',
    //     950: '#00002d',
    // },
    colorScheme: {
      light: {
        secondary: {
          color: '{secondary.600}',
          contrastColor: '#ffffff',
          hoverColor: '{secondary.700}',
          activeColor: '{secondary.800}',
        },
        primary: {
          color: '{primary.600}',
          contrastColor: '#ffffff',
          hoverColor: '{primary.700}',
          activeColor: '{primary.800}',
        },
        highlight: {
          background: '{primary.50}',
          focusBackground: '{primary.100}',
          color: '{primary.800}',
          focusColor: '{primary.900}',
        },
      },
      dark: {
        primary: {
          color: '{primary.300}',
          contrastColor: '{surface.900}',
          hoverColor: '{primary.200}',
          activeColor: '{primary.100}',
        },
        highlight: {
          background: 'color-mix(in srgb, {primary.400}, transparent 84%)',
          focusBackground: 'color-mix(in srgb, {primary.400}, transparent 76%)',
          color: 'rgba(255,255,255,.87)',
          focusColor: 'rgba(255,255,255,.87)',
        },
      },
    },
  },
});

/**
 * Upv Preset
 * Alternative custom theme for UPV IoT sensors
 */
const UpvPreset = definePreset(Aura, {
  semantic: {
    primary: Aura.primitive.red,
    // {
    //     50: '#fff5f5',
    //     100: '#fecece',
    //     200: '#fda7a7',
    //     300: '#fd8181',
    //     400: '#fc5a5a',
    //     500: '#fb3333',
    //     600: '#d52b2b',
    //     700: '#b02424',
    //     800: '#8a1c1c',
    //     900: '#641414',
    //     950: '#3f0d0d',
    // },
    colorScheme: {
      light: {
        primary: {
          color: '{primary.600}',
          contrastColor: '#ffffff',
          hoverColor: '{primary.700}',
          activeColor: '{primary.800}',
        },
        highlight: {
          background: '{primary.50}',
          focusBackground: '{primary.100}',
          color: '{primary.800}',
          focusColor: '{primary.900}',
        },
      },
      dark: {
        primary: {
          color: '{primary.400}',
          contrastColor: '{surface.900}',
          hoverColor: '{primary.300}',
          activeColor: '{primary.200}',
        },
        highlight: {
          background: 'color-mix(in srgb, {primary.400}, transparent 84%)',
          focusBackground: 'color-mix(in srgb, {primary.400}, transparent 76%)',
          color: 'rgba(255,255,255,.87)',
          focusColor: 'rgba(255,255,255,.87)',
        },
      },
    },
  },
});

/**
 * Preset mapping object
 * Maps customization theme keys to their corresponding PrimeNG presets
 */
export const THEME_PRESETS: Record<string, any> = {
  default: CosmosPreset,
  cemex: CemexPreset,
  upv: UpvPreset,
};

/**
 * Resolve the initial preset from localStorage
 * Used during providePrimeNG initialization
 */
export function getInitialPreset(): any {
  if (typeof window === 'undefined') return CosmosPreset;

  const savedTheme = localStorage.getItem(LOCAL_STORAGE_THEME_KEY);
  if (savedTheme) {
    const preset = THEME_PRESETS[savedTheme];
    return preset || CosmosPreset;
  }
  return CosmosPreset;
}
